const isMobileAnim = typeof matchMedia !== "undefined" && matchMedia("(pointer: coarse)").matches || typeof navigator !== "undefined" && navigator.maxTouchPoints > 0;
const MOBILE_FADE_DURATION = 400;
const MOBILE_FADE_EASING = "ease-out";
const MOBILE_TRANSLATE_Y = "12px";
export {
  MOBILE_FADE_DURATION,
  MOBILE_FADE_EASING,
  MOBILE_TRANSLATE_Y,
  isMobileAnim
};
